import React from 'react';
import { useHistory } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { captureException } from '@playbookux/playbook-web-core';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

/* eslint-disable import/no-unresolved */
import useStore from 'playbook-web/store';

import {
  fetchCompany,
} from '../../../../../../core/actions';

import TemplateHeaderContent from '../../../components/template/template-header/content';
import {
  ConsentConfigToggleContainer, ToggleButton, ToggleContainer, GenericContentContainer, Blocker,
} from './styles';
import {
  TEMPLATE_TYPES, BUTTON_TEXT_MAP, DESCRIPTION_MAP, TITLE_MAP,
} from '../../../constants';
import { UPDATE_COMPANY_CONSENT_FORM_REQUIRED } from '../../../../../../core/graphql/consent-forms';

const ConsentFormSelectorKey = TEMPLATE_TYPES.CONSENT;

const ConsentFormManagementComponentHeader = (props) => {
  const {
    isConsentFormRequired,
    companyId,
    refetchConsentFormRequired,
    canSetCompanyConsentFormRequired,
    onFetchCompany,
  } = props;

  const history = useHistory();
  const [
    updateCompanyConsentFormRequiredMutation,
  ] = useMutation(
    UPDATE_COMPANY_CONSENT_FORM_REQUIRED,
  );

  const setCompany = useStore((state) => state.setCompany);
  const company = useStore((state) => state.company);

  const handleCreateTemplate = async () => {
    history.push('/template-library/consent-form');
  };

  const handleToggle = async () => {
    try {
      await updateCompanyConsentFormRequiredMutation({
        variables: {
          consentFormRequired: !isConsentFormRequired,
          id: companyId,
        },
      });
      setCompany({ ...company, consentFormRequired: !isConsentFormRequired });
      onFetchCompany(companyId);
    } catch (exception) {
      captureException('ERROR_DELETING_CONSENT_FORM', exception);
    }
    refetchConsentFormRequired();
  };

  return (
    <>
      <GenericContentContainer>
        <TemplateHeaderContent
          title={TITLE_MAP[ConsentFormSelectorKey]}
          description={DESCRIPTION_MAP[ConsentFormSelectorKey]}
          buttonText={BUTTON_TEXT_MAP[ConsentFormSelectorKey]}
          handleCreateTemplate={handleCreateTemplate}
          learnMoreLink="https://help.playbookux.com/en/articles/8113804-custom-consent-forms"
        />

      </GenericContentContainer>
      <ConsentConfigToggleContainer>
        <ToggleContainer>
          <ToggleButton
            checked={isConsentFormRequired}
            onChange={handleToggle}
            id="ToggleComponent"
            disabled={!canSetCompanyConsentFormRequired}
          />
          {
            !canSetCompanyConsentFormRequired
            && <Blocker />
          }
        </ToggleContainer>
        Consent forms are required for this workspace
      </ConsentConfigToggleContainer>
    </>
  );
};

ConsentFormManagementComponentHeader.propTypes = {
  isConsentFormRequired: PropTypes.bool,
  companyId: PropTypes.string.isRequired,
  refetchConsentFormRequired: PropTypes.func.isRequired,
  canSetCompanyConsentFormRequired: PropTypes.bool.isRequired,
  onFetchCompany: PropTypes.func,
};

ConsentFormManagementComponentHeader.defaultProps = {
  isConsentFormRequired: false,
  onFetchCompany: () => null,
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  onFetchCompany: fetchCompany,
}, dispatch);

export default connect(null, mapDispatchToProps)(ConsentFormManagementComponentHeader);
